import { expandCollapseManager } from '@wix/chat-web';
import { loadingScheduler } from '../loading-scheduler';
import wix from '../wix';
import { lazilyLoadFirebase, loadFirebase } from './firebase-loader';

const INTERACTIVITY_DELAY_THRESHOLD = 5000;

export const triggerInteractivity = () =>
  void loadingScheduler
    .onConnective()
    .then(loadingScheduler.triggerInteractivity);

const loadLazily = (
  unpkgUrl: string,
  leanHeader: boolean,
  chatToken?: string,
) => {
  if (!leanHeader || !chatToken) {
    void loadFirebase(unpkgUrl).then(loadingScheduler.triggerConnectivity);
  } else {
    void lazilyLoadFirebase(
      unpkgUrl,
      chatToken,
      INTERACTIVITY_DELAY_THRESHOLD,
    ).then(loadingScheduler.triggerConnectivity);
  }

  const triggerInteractivityHandler = () => {
    void loadFirebase(unpkgUrl).then(loadingScheduler.triggerConnectivity);
    triggerInteractivity();

    window.removeEventListener('mouseover', triggerInteractivityHandler);
    expandCollapseManager.unregisterOnExpand(triggerInteractivityHandler);
  };

  window.addEventListener('mouseover', triggerInteractivityHandler);
  expandCollapseManager.registerOnExpand(triggerInteractivityHandler);
  window.setTimeout(triggerInteractivityHandler, INTERACTIVITY_DELAY_THRESHOLD);
};

const loadRegularly = () => {
  loadingScheduler.triggerConnectivity();

  if (window.requestIdleCallback) {
    window.requestIdleCallback(triggerInteractivity);
  }
  wix.onReady(triggerInteractivity);
};

export const loadChat = ({ widgetMode, unpkgUrl, leanHeader, chatToken }) => {
  const isSiteMode = widgetMode === 'site';

  if (isSiteMode) {
    loadLazily(unpkgUrl, leanHeader, chatToken);
  } else {
    loadRegularly();
  }
};
